<template>
  <form @submit.prevent="submitPreApprovalStep1()" class="grid gap-4 w-full min-w-formFullWidth">
    <!-- Personal Details -->
    <details :open="!(personalInfo?.firstName) ||
      !personalInfo?.pan || !personalInfo?.dob || !personalInfo?.gender || !personalInfo?.email"
      v-on:toggle="handlePersonalDetailsToggle">
      <summary
        class="marker-none list-none pr-8 bg-details-gray-arrow bg-no-repeat cursor-pointer focus:outline-none outline-none py-3 text-sm summary-css"
      >
      <section class="flex gap-2 items-center">
        <div>
          <img src="../assets/personal-details.svg" class="h-8 w-8" alt="personal details img"/>
        </div>
        <aside>
          <p class="heading-text-medium">Personal Details</p>
          <transition name="out-in">
            <article v-if="isPersonalDetailsToggle" class="grid grid-cols-2 gap-1">
              <div v-if="personalInfo?.firstName" class="flex gap-1">
                <p class="secondary-heading-text-blogger whitespace-nowrap truncate w-32">
                  Name: <span class="secondary-headingColor-text font-semibold">{{ personalInfo?.firstName }}</span>
                </p>
              </div>
              <div v-if="personalInfo?.pan" class="flex gap-1">
                <p class="secondary-heading-text-blogger">
                  Pan: <span class="secondary-headingColor-text font-semibold">{{ personalInfo?.pan?.toUpperCase() }}</span>
                </p>
              </div>
            </article>
          </transition>
        </aside>
      </section>
      </summary>
      <section class="summary-section">
        <aside class="px-4 grid gap-2 py-2">
          <div>
            <p class="label-text-medium">Name (As per PAN)</p>
            <input
              type="text"
              name="name"
              id="name"
              class="input mt-1"
              v-model.trim="params.personalInfo.firstName"
              required
            />
          </div>
           <div>
            <p class="label-text-medium">PAN</p>
            <p v-if="personalInfo?.pan" class="label-text-myriad">{{ personalInfo?.pan?.toUpperCase() }}</p>
            <input
              v-else
              type="text"
              name="pan-number"
              id="pan-number"
              class="input mt-1"
              required
              minlength="10"
              maxlength="10"
              :value="params.personalInfo.pan?.toUpperCase()"
              @input="params.personalInfo.pan = $event.target.value.toUpperCase().trim()"
              @keydown="restrictPANInput"
            />
          </div>
           <div>
            <p class="label-text-medium">Date of Birth (As per PAN)</p>
            <p v-if="personalInfo?.dob" class="label-text-myriad">{{ personalInfo?.dob }}</p>
            <input
              v-else
              type="date"
              name="dob"
              placeholder="DD/MM/YYYY"
              v-model.trim="params.personalInfo.dob"
              class="input mt-1"
              required
              :max="maxDate"
              min="1900-01-01"
            />
          </div>
           <div>
            <p class="label-text-medium">Gender</p>
            <p v-if="personalInfo?.gender" class="label-text-myriad">{{ personalInfo?.gender }}</p>
            <div v-else class="grid grid-cols-2 gap-2 mt-1">
              <radio-button
                label="Male"
                name="gender"
                id="male"
                :required="true"
                value="Male"
                @change="saveValue"
                labelWidth
                class=""
                :alternate="params.personalInfo.gender === 'Male'"
              />
              <radio-button
                label="Female"
                name="gender"
                id="female"
                :required="true"
                value="Female"
                labelWidth
                @change="saveValue"
                :alternate="params.personalInfo.gender === 'Female'"
                class=""
              />
              <radio-button
                label="Other"
                name="gender"
                id="other"
                :required="true"
                labelWidth
                @change="saveValue"
                :alternate="params.personalInfo.gender === 'Other'"
                value="Other"
              />
            </div>
          </div>
          <div>
            <p class="label-text-medium">Email</p>
            <input
              type="email"
              name="Email"
              id="email"
              class="input"
              placeholder="Enter Email"
              v-model.trim="params.personalInfo.email"
              required
              pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
            />
          </div>
        </aside>
      </section>
    </details>
    <!-- Business Details -->
    <details open v-on:toggle="handleBusinessDetailsToggle">
      <summary
        class="marker-none pr-8 list-none bg-details-gray-arrow bg-no-repeat cursor-pointer focus:outline-none outline-none py-3 text-sm summary-css"
      >
      <section class="flex gap-2 items-center">
        <div>
          <img src="../assets/bussiness-details.svg" class="h-8 w-8" alt="personal details img"/>
        </div>
        <aside>
          <p class="heading-text-medium">Business Details</p>
          <transition name="out-in">
            <article v-if="isBusinessDetailsToggle">
              <div v-if="businessInfo?.gstin" class="flex gap-1">
                <p class="secondary-heading-text-blogger">
                  GSTIN:
                </p>
                <p class="secondary-headingColor-text font-semibold">
                  {{ businessInfo?.gstin }}
                </p>
              </div>
              <div v-if="businessInfo?.name" class="flex gap-1">
                <p class="secondary-heading-text-blogger whitespace-nowrap truncate w-32">
                  Business Name: <span class="secondary-headingColor-text font-semibold">{{ businessInfo?.name }}</span>
                </p>
              </div>
            </article>
          </transition>
        </aside>
      </section>
      </summary>
      <!-- with out gst -->
      <section class="summary-section">
        <aside class="px-4 grid gap-2 py-2">
          <div>
            <p class="label-text-medium">Business Name</p>
            <p v-if="businessInfo?.name" class="label-text-myriad">{{ businessInfo?.name }}</p>
            <input
              v-else
              type="text"
              name="business-name"
              id="business-name"
              class="input"
              placeholder=""
              required
              v-model.trim="params.businessInfo.BName"
            />
          </div>
           <div class="grid gap-1">
            <p class="label-text-medium">Address Line (Business)</p>
            <input
              type="text"
              name="Residential Address"
              id="residential-address"
              class="input uppercase"
              placeholder=""
              v-model.trim="params.businessInfo.addressAsPerBusiness.line1"
              required
              minlength="5"
              maxlength="100"
            />
          </div>
           <div class="grid gap-1">
            <p class="label-text-medium">PIN code (Business)</p>
            <input
              type="text"
              inputmode="numeric"
              name="Pincode"
              id="pincode"
              class="input"
              placeholder=""
              maxlength="6"
              minlength="6"
              pattern="[0-9]{6}"
              v-model.trim="params.businessInfo.addressAsPerBusiness.pincode"
              required
              @keypress="isNumber"
              @input="checkLengthPinCode"
            />
          </div>
          <div v-if="businessInfoPrams.city && businessInfoPrams.state">
            <p class="label-text-medium">City / State</p>
            <p class="label-text-myriad">{{ businessInfoPrams.city }}, {{ businessInfoPrams.state }}</p>
          </div>
          <div class="grid gap-2" v-else>
            <div class="grid gap-1">
              <p class="label-text-medium">City</p>
              <input
                type="text"
                name="City"
                id="city"
                class="input"
                placeholder=""
                v-model.trim="params.businessInfo.addressAsPerBusiness.city"
                required
                :disabled="disableCityStateResidence"
              />
            </div>
            <div class="grid gap-1">
              <p class="label-text-medium">State</p>
              <input
                type="text"
                name="State"
                id="state"
                class="input"
                placeholder=""
                v-model.trim="params.businessInfo.addressAsPerBusiness.state"
                required
                :disabled="disableCityStateResidence"
              />
            </div>
          </div>
        </aside>
      </section>
    </details>
    <!-- tnc -->
    <fieldset class="text-left md:w-auto w-full flex gap-4 pr-2 pl-1" v-if="!tncAccepted">
      <legend></legend>
      <span class="p-px">
        <input checked @click="getCheckBoxValue($event)"  type="checkbox" name="tnc" id="tnc" required class="text-primary" />
      </span>
      <label for="tnc" class="text-xs text-textSecondary text-justify">
        I have read, understood and I agree to the contents of this agreement, and I hereby give my consent to ARTHASHASTRA EPAYLATER FINANCIAL PRIVATE LIMITED and authorize it, its financial partners, and its co-lenders to obtain my credit information from credit bureaus including but not limited to Experian, TransUnion CIBIL, Equifax, and CRIF High Mark for the purpose of providing deferred payment options and/or other credit products, and for assessing my credit eligibility for such products from time to time in the future. I also agree to
        <span
          @click.prevent="openUrl('https://s3.ap-south-1.amazonaws.com/epaylater-marketing/Experian_Terms.pdf')"
          class="text-primary underline cursor-pointer"
        >Experian Terms and Conditions</span>, TransUnion CIBIL Terms and conditions, Equifax Terms and Conditions, CRIF Highmark Terms and Conditions and
        <span
          class="text-primary underline cursor-pointer"
          @click.prevent="openUrl(tncUrl)"
        >ePayLater Standard Terms and Conditions</span>. I consent to receiving communication via SMS, email, and WhatsApp.
      </label>
    </fieldset>
    <span class="grid pb-10"></span>
    <section class="footer">
      <CustomButton
        :variant="isFormValid ? 'primary' : 'disableGray'"
        :disabled="!isFormValid"
        type="submit"
        class="btn--normal btn"
      >
        Confirm Details
      </CustomButton>
    </section>
    <error-message-popup
      v-if="errorPopupMessage"
      @close-modal="errorPopupMessage = undefined"
      :errorPopupMessage="errorPopupMessage"
      routeLink="Pre Approval Step 1"
      actionButtonText="Ok"
      :defaultContinueAnyways="false"
      @continue-anyways="errorPopupMessage = undefined"
    />
    <!-- Spin Loader -->
    <spin-loader
      :secondaryText="isSpinTextShow ? 'This should take a few seconds' : undefined"
      :textSpinner="isSpinTextShow ? 'Please wait while we calculate' : undefined"
      :subTextSpinner="isSpinTextShow ? 'your limit' : undefined"
      :spinLoading="isSpinLoading"
    />
  </form>
</template>
<script>
import { mapGetters } from "vuex";
import RadioButton from '../components/RadioButton.vue';
import CustomButton from "../components/CustomButton.vue";
import ErrorMessagePopup from "../components/ErrorMessagePopup.vue";
import SpinLoader from '../components/spinLoader.vue';

export default {
  name: 'PreApprovalStep1',
  components: {
    RadioButton,
    CustomButton,
    ErrorMessagePopup,
    SpinLoader
  },
  computed: {
    ...mapGetters([
      'isReferralFlow',
      'applicationId',
      'flagsData',
      'videoVerified',
      'personalInfo',
      'businessInfo',
      'notShowError',
      'tncUrl'
    ]),
    maxDate() {
      const date = new Date();
      const maxDate = new Date(
        new Date().setUTCFullYear(date.getUTCFullYear() - 18)
      );
      return `${maxDate.getUTCFullYear()}-${(
        maxDate.getUTCMonth() + 1
      ).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}-${maxDate.getUTCDate().toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}`;
    },
    isFormValid() {
      const { params } = this;
      return (
        params.review
      );
    },
  },
  data() {
    return {
      isSpinTextShow: undefined,
      isSpinLoading: undefined,
      isPersonalDetailsToggle: true,
      isBusinessDetailsToggle: true,
      selectedMarketplace: undefined,
      tncAccepted: undefined,
      disableCityStateResidence: false,
      params: {
        personalInfo: {
          firstName: undefined,
          pan: undefined,
          dob: undefined,
          gender: undefined,
          email: undefined
        },
        businessInfo: {
          gstin: undefined,
          BName: undefined,
          addressAsPerBusiness: {
            pincode: undefined,
            line1: undefined,
            city: undefined,
            state: undefined
          }
        },
        review: true,
      },
      businessInfoPrams: {
        city: undefined,
        state: undefined
      },
      errorPopupMessage: undefined,
    };
  },
  watch: {
    'params.businessInfo.addressAsPerBusiness.pincode': function getPincode() {
      this.disableCityStateResidence = false;
      if (
        this.params.businessInfo.addressAsPerBusiness.pincode &&
        this.params.businessInfo.addressAsPerBusiness.pincode.length === 6 &&
        this.params.businessInfo.addressAsPerBusiness.pincode.match(/[0-9]{6}/)
      ) {
        this.getPincode(this.params.businessInfo.addressAsPerBusiness.pincode)
          .then((result) => {
            if (result) {
              if (result.state !== undefined && result.city !== undefined) {
                this.params.businessInfo.addressAsPerBusiness.state = result.state;
                this.params.businessInfo.addressAsPerBusiness.city = result.city;
                this.disableCityStateResidence = true;
              }
            } else {
              this.disableCityStateResidence = false;
              this.params.businessInfo.addressAsPerBusiness.state = '';
              this.params.businessInfo.addressAsPerBusiness.city = '';
              this.businessInfoPrams.state = '';
              this.businessInfoPrams.city = '';
            }
          })
          .catch(() => {
            this.disableCityStateResidence = false;
            this.businessInfoPrams.state = '';
            this.businessInfoPrams.city = '';
          });
      }
    },

  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_LANDING_DETAILS);
      this.params.personalInfo.firstName = this.personalInfo?.firstName;
      this.params.personalInfo.email = this.personalInfo.email;
      this.params.businessInfo.addressAsPerBusiness.line1 = this.businessInfo?.address?.line1;
      this.params.businessInfo.addressAsPerBusiness.pincode = this.businessInfo?.address?.pincode;
      this.businessInfoPrams.city = this.businessInfo?.address?.city;
      this.businessInfoPrams.state = this.businessInfo?.address?.state;
    },
    restrictPANInput(event) {
      const value = this.params.personalInfo.pan || '';
      const key = event.key.toUpperCase();

      // Allow Backspace, Tab, Delete, Left/Right Arrow keys
      if (['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        return;
      }

      // Prevent input beyond 10 characters
      if (value.length >= 10) {
        event.preventDefault();
        return;
      }

      // First 5 characters: Only letters (A-Z)
      if (value.length < 5 && !/[A-Z]/.test(key)) {
        event.preventDefault();
        return;
      }

      // Next 4 characters: Only numbers (0-9)
      if (value.length >= 5 && value.length < 9 && !/[0-9]/.test(key)) {
        event.preventDefault();
        return;
      }

      // Last character: Only a letter (A-Z)
      if (value.length === 9 && !/[A-Z]/.test(key)) {
        event.preventDefault();
      }
    },
    checkLengthPinCode(e) {
      if (e.target.value.length !== 6) {
        this.disableCityStateResidence = false;
        this.businessInfoPrams.state = '';
        this.businessInfoPrams.city = '';
        this.params.businessInfo.addressAsPerBusiness.state = '';
        this.params.businessInfo.addressAsPerBusiness.city = '';
      }
    },
    openUrl(urlLink) {
      window.microapps.openUrl({
        url: urlLink
      });
    },
    handlePersonalDetailsToggle(event) {
      const detailsElement = event.target;

      if (detailsElement.open) {
        this.isPersonalDetailsToggle = false;
      } else {
        this.isPersonalDetailsToggle = true;
      }
    },
    handleBusinessDetailsToggle(event) {
      const detailsElement = event.target;

      if (detailsElement.open) {
        this.isBusinessDetailsToggle = false;
      } else {
        this.isBusinessDetailsToggle = true;
      }
    },
    saveValue(event) {
      this.params.personalInfo.gender = event.target.value;
    },
    getPincode(pincode) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('getPincode', pincode)
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    getCheckBoxValue(event) {
      this.params.review = event.target.checked;
    },
    submitPreApprovalStep1() {
      this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_CONFIRM_DETAILS);
      const patternPanNumberInput = /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(this.params.personalInfo.pan);
      if (this.params.personalInfo.pan && !this.personalInfo?.pan && !patternPanNumberInput) {
        this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_INVALID_PAN_NUMBER, {
          [this.$mixpanelPayload.INVALID]: this.params.personalInfo.pan || this.personalInfo?.pan || patternPanNumberInput,
        });
        this.params.personalInfo.pan = '';
        this.$store.commit('SET_ERROR_MESSAGE', 'Please enter a valid PAN number');
        return;
      }
      this.isSpinTextShow = true;
      this.isSpinLoading = true;
      const params = {
        patchParams: {
          tncId: this.flagsData?.tncId, // need to verify
          personalInfo: {
            firstName: this.params.personalInfo.firstName || this.personalInfo?.firstName || '',
            pan: this.personalInfo?.pan || this.params.personalInfo.pan,
            genderS: this.personalInfo?.gender || this.params.personalInfo.gender,
            dob: this.personalInfo?.dob || this.params.personalInfo.dob,
            email: this.params.personalInfo.email
          },
          businessInfo: {
            name: this.params.businessInfo.BName || this.businessInfo?.name,
            gstin: this.params.businessInfo.gstin || this.businessInfo?.gstin,
            pan: this.personalInfo?.pan || this.params.personalInfo.pan,
            address: {
              pincode: this.params.businessInfo.addressAsPerBusiness.pincode,
              line1: this.params.businessInfo.addressAsPerBusiness.line1,
              city: this.params.businessInfo.addressAsPerBusiness.city,
              state: this.params.businessInfo.addressAsPerBusiness.state,
            }
          }
        },
        urlParams: {
          review: this.params.review
        }
      };
      this.$store
        .dispatch('gPayShortReferral', params)
        .then((response) => {
          this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_SHORT_REFERRAL_API, {
            [this.$mixpanelPayload.REASON]: 'success'
          });
          this.isSpinLoading = false;
          if (response.success) {
            this.getApplicationApprovals();
          } else {
            this.isSpinLoading = false;
            this.errorPopupMessage = response;
          }
          if (!this.tncAccepted) {
              const postParams = {
              consentStatus: "granted",
              consentType: "whatsapp",
            };
            this.$store
              .dispatch("consentStatus", { postParams })
              .then(() => {})
              .catch(() => {
              });
            }
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_SHORT_REFERRAL_API, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message
          });
          this.isSpinLoading = false;
        });
    },
     getApprovals() {
      this.$store.dispatch('applicationApprovals', {
        applicationId: this.applicationId,
        urlParams: { option: 'best' },
      }).then((result) => {
        if (result.showApproval) {
          this.$router.push({
            name: 'Pre Approval Congratulations',
            query: {
              nextRoute: this.$route.meta.isEdit ? 'Pre Approval Review' : 'Pre Approval KYC Selection'
            }
          });
        } else {
          this.$router.push({
            name: this.$route.meta.isEdit ? 'Pre Approval Review' : 'Pre Approval KYC Selection',
            params: {
              applicationId: this.applicationId,
            },
          });
        }
      }).catch(() => {
      });
    },
    getApplicationApprovals() {
      this.$store
        .dispatch('applicationApprovals', {
          applicationId: this.applicationId,
          urlParams: {
            option: 'best',
          },
        })
        .then((response) => {
          if (response?.result[0]?.amountApproved === 0 && response?.result[0]?.skipOfferScreen) {
            this.$router.push({
              name: 'Current Address',
              query: {
                skipOfferScreen: true,
              }
            });
          } else if (response?.result[0]?.amountApproved === 0 && !response?.result[0]?.skipOfferScreen) {
            this.$router.push({
              name: "Application Rejected",
            });
          } else if (response?.result[0]?.amountApproved > 0) {
            localStorage.setItem('creditOfferData', JSON.stringify(response?.result[0]));
            this.$router.push({
              name: 'Credit Offer Selection',
            });
          } else {
            this.$router.push({
              name: "Application Rejected",
            });
          }
        })
        .catch(() => { });
    },
    getApprovalsSkipBusinessProfileInReferral() {
      this.$store.dispatch('applicationApprovals', {
        applicationId: this.applicationId,
        urlParams: { option: 'best' },
      }).then((result) => {
        if (result.showApproval) {
          if (result.result[0]?.amountApproved > 0) {
            this.$router.push({
              name: 'Pre Approval Congratulations',
              query: {
                nextRoute: 'Pre Approval Review',
              }
            });
          } else if (result.result[0]?.amountApproved === 0 || result?.result[0]?.amountApproved === undefined) {
            this.$router.push({
              name: 'Pre Approval Review',
              params: {
                applicationId: this.applicationId,
              },
            });
          }
        }
      }).catch(() => {
      });
    },
  },
};
</script>
<style scoped lang="scss">
.summary-css{
  border: 1px solid #E8E8E8;
  padding: 1.2rem;
  border-radius: 1rem;
}
.summary-section{
  border: 1px solid #E8E8E8;
  padding: 1rem;
  border-radius: 0px 0px 1rem 1rem;
  margin-top: -10px;
  border-top: none;
}
.summary-section-gstin{
  border: 1px solid #E8E8E8;
  border-radius: 0px 0px 1rem 1rem;
  border-top: none;
}
/* Style the custom date input */
input[type="date"] {
  color: transparent; /* Hide the default placeholder text */
}

/* Style for custom placeholder */
input[type="date"]::placeholder {
  color: #aaa; /* Set the color of the custom placeholder */
}
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
}
input[type="date"]:before {
    background: url(../assets/calendar_icon_new.svg) no-repeat;
    content: attr(placeholder) !important;
    color: #aaa;
    margin-right: 0.5em;
    padding-top: 0.25rem;
    padding-left: 2rem;
  }
  input[type="date"]:valid:before {
    content: url(../assets/calendar_icon_new.svg) attr(value) !important;
    color: initial;
    background: none; /* Remove the background image */
    padding-top: 0.25rem !important;
    padding-left: 0rem !important;
    margin-right: 0rem !important;
  }
  input[type="date"]:valid {
    color: black !important; /* Change to your desired text color */
}

.custom-radio {
  /* Remove default styling */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Base look */
  border: 1px solid #00517B;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  background-color: transparent;
  outline: none;

  /* Prevent flicker */
  background-clip: padding-box;
  box-sizing: border-box;
  transition:
    border-color 0.15s ease-in-out,
    background-color 0.15s ease-in-out;
}

.custom-radio::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  background-color: #00517B;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.15s ease-in-out;
  will-change: transform;
}

.custom-radio:checked {
  border-color: #00517B;
  background-color: #fff; /* Keeps it white when checked */
}

.custom-radio:checked::after {
  transform: translate(-50%, -50%) scale(1);
}

.custom-radio:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 81, 123, 0.2);
}

</style>
